import axiosInstance from '../axios.instance';

export const getAllCollectionsApi = (token) => axiosInstance.get('/collection/all', {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const getUserCollectionsApi = (name) => axiosInstance.get(`/collection/user/${name}`);

export const getCollectionBySlugApi = (slug, page = 1) => axiosInstance.get(`/collection/one/${slug}?page=${page}`);

export const createCollectionApi = (data, token) => axiosInstance.post('/collection/make', data, {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const editCollectionApi = (id, data, token) => axiosInstance.put(`/collection/edit/${id}`, data, {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const uploadAssetsApi = (data, token) => axiosInstance.post('/collection/upload', data, {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const checkSlugUrlApi = (url, token) => axiosInstance.post('/collection/check-slug-url', url, {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const deleteCollectionApi = (id, token) => axiosInstance.delete(`/collection/delete/${id}`,  {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const addCollectionProductsApi = (data, token) => axiosInstance.post(`/collection/add`, data,  {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});

export const deleteCollectionProductsApi = (collectionId, productId, token) => axiosInstance.delete(`/collection/delete/${collectionId}/product/${productId}`,  {
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    },
});